/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Component, Input, ViewChild } from '@angular/core';
var SnLetterAvatarComponent = /** @class */ (function () {
    function SnLetterAvatarComponent() {
        this.type = 'primary';
        this.inverse = false;
        this.dimensions = {
            width: '',
            height: '',
            lineHeight: ''
        };
    }
    /**
     * @return {?}
     */
    SnLetterAvatarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var el = this.letterDisplay.nativeElement;
        /** @type {?} */
        var fontSize = parseInt(window
            .getComputedStyle(el, undefined)
            .getPropertyValue('font-size'), 10);
        /** @type {?} */
        var diameter = fontSize + fontSize * 1.5;
        this.setDiameter(diameter);
    };
    /**
     * @param {?} diameter
     * @return {?}
     */
    SnLetterAvatarComponent.prototype.setDiameter = /**
     * @param {?} diameter
     * @return {?}
     */
    function (diameter) {
        this.dimensions = {
            width: diameter + "px",
            height: diameter + "px",
            lineHeight: diameter + "px"
        };
    };
    SnLetterAvatarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sn-letter-avatar',
                    template: "\n        <span\n            [ngClass]=\"[\n                'letter-avatar',\n                'letter-avatar-' + type + (inverse ? '-inverse' : '')\n            ]\"\n            #letterDisplay\n            [ngStyle]=\"dimensions\"\n        >\n            <ng-content></ng-content>\n        </span>\n    "
                }] }
    ];
    SnLetterAvatarComponent.propDecorators = {
        type: [{ type: Input }],
        inverse: [{ type: Input }],
        letterDisplay: [{ type: ViewChild, args: ['letterDisplay',] }]
    };
    return SnLetterAvatarComponent;
}());
export { SnLetterAvatarComponent };
if (false) {
    /** @type {?} */
    SnLetterAvatarComponent.prototype.type;
    /** @type {?} */
    SnLetterAvatarComponent.prototype.inverse;
    /** @type {?} */
    SnLetterAvatarComponent.prototype.letterDisplay;
    /** @type {?} */
    SnLetterAvatarComponent.prototype.dimensions;
}
//# sourceMappingURL=data:application/json;base64,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